import { matchVersion } from '../../utils';
import __regexp from './__chromium-based-regexp';
/** Detect Chromium-based Browser version */
export default function isChromiumBasedVersion(operator, version) {
	return function (ua) {
		return matchVersion({
			ua: ua,
			version: version,
			operator: operator,
			regExp: __regexp,
			groupIndex: 1
		});
	};
}
